import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Box,
  Typography
} from '@mui/material';
import { Business as BusinessIcon } from '@mui/icons-material';

const AddBranchDialog = ({ addBranch, open, onClose }) => {
    const [branchName, setBranchName] = React.useState('');
    const [branchAddress, setBranchAddress] = React.useState('');
    const [branchContact, setBranchContact] = React.useState('');

    const resetFields = () => { 
        setBranchName('');
        setBranchAddress('');
        setBranchContact('');
    }

    const handleSave = () => {
      if (branchName.trim() && branchAddress.trim() && branchContact.trim()) {
        addBranch({
          'id': Date.now(),
          'nombre': branchName.trim(),
          'direccion': branchAddress.trim(),
          'contacto': branchContact.trim()
        });
        resetFields();
        onClose();
      }
    };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1, borderBottom: '1px solid #e0e0e0', pb: 2 }}>
        <BusinessIcon color="primary" />
        <Typography variant="h6" fontWeight={600}>
          Agregar Nueva Sucursal
        </Typography>
      </DialogTitle>

      <DialogContent sx={{ pt: 3 }}>
        <Box display="flex" flexDirection="column" gap={3}>
          <Box>
            <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 600, mb: 1 }}>
              Nombre de la Sucursal *
            </Typography>
            <TextField
              placeholder="Nombre de la sucursal"
              fullWidth
              value={branchName}
              onChange={(e) => setBranchName(e.target.value)}
              sx={{
                '& .MuiOutlinedInput-root': {
                  backgroundColor: '#F8F9FA',
                  borderRadius: 1,
                },
              }}
            />
          </Box>
          <Box>
            <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 600, mb: 1 }}>
              Dirección Física *
            </Typography>
            <TextField
              value={branchAddress}
              onChange={(e) => setBranchAddress(e.target.value)}
              placeholder="Dirección física"
              fullWidth
              sx={{
                '& .MuiOutlinedInput-root': {
                  backgroundColor: '#F8F9FA',
                  borderRadius: 1,
                },
              }}
            />
          </Box>
          <Box>
            <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 600, mb: 1 }}>
              Teléfono o Contacto Interno *
            </Typography>
            <TextField
              value={branchContact}
              onChange={(e) => setBranchContact(e.target.value)}
              placeholder="Teléfono o contacto interno"
              fullWidth
              sx={{
                '& .MuiOutlinedInput-root': {
                  backgroundColor: '#F8F9FA',
                  borderRadius: 1,
                },
              }}
            />
          </Box>
        </Box>
      </DialogContent>

      <DialogActions sx={{ borderTop: '1px solid #e0e0e0', pt: 2, px: 3, pb: 2 }}>
        <Button
          variant='outlined'
          onClick={() => { onClose(); resetFields(); }}
          sx={{
            textTransform: 'none',
            fontWeight: 600,
            borderRadius: 1,
            borderColor: '#18586b',
            color: '#18586b',
            '&:hover': {
              borderColor: '#0f4c75',
              backgroundColor: 'rgba(24, 88, 107, 0.04)',
            },
          }}
        >
          Cancelar
        </Button>
        <Button
          onClick={handleSave}
          variant='contained'
          disabled={!branchName.trim() || !branchAddress.trim() || !branchContact.trim()}
          sx={{
            fontWeight: 600,
            textTransform: 'none',
            borderRadius: 1,
            backgroundColor: '#18586b',
            '&:hover': {
              backgroundColor: '#0f4c75',
            },
          }}
        >
          Guardar Sucursal
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddBranchDialog;
